// Dawn rewrites the add to cart label on every variant change. Put "Pre-order" and its note back
// when the newly chosen variant is a pre-order one.
(() => {
  if (window.scPreorderReady || typeof subscribe !== 'function') return;
  window.scPreorderReady = true;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, html } }) => {
    const source = html.getElementById(`ProductSubmitButton-${sectionId}`);
    const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
    if (source && button) {
      button.dataset.scPreorder = source.dataset.scPreorder;
      if (source.dataset.scPreorder === 'true' && !button.disabled) {
        button.querySelector('span').textContent = source.querySelector('span').textContent.trim();
      }
    }

    const sourceNote = html.getElementById(`ScPreorder-${sectionId}`);
    const note = document.getElementById(`ScPreorder-${sectionId}`);
    if (sourceNote && note) note.hidden = sourceNote.hidden;
  });
})();
